// extracted by mini-css-extract-plugin
export default {"collapse":"LTxIo0_nqiI228xypBQp","links":"nPcqpxGWpcoFoamgY30q"};